var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_46_copy",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m42.847,47.892v29.543c2.165,1.05,4.585,1.656,7.153,1.656s4.988-.606,7.153-1.656v-29.543c-2.165-1.05-4.585-1.656-7.153-1.656s-4.988.606-7.153,1.656Z",
        },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m43.847,23.319h12.305c.552,0,1,.448,1,1v59.94c0,2.76-2.24,5-5,5h-4.305c-2.76,0-5-2.24-5-5V24.319c0-.552.448-1,1-1Z",
        },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "42.847", y1: "37.678", x2: "57.152", y2: "37.678" },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "42.847", y1: "33.007", x2: "57.152", y2: "33.007" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }